var render = function render(_c, _vm) {
  return _c(
    "v-row",
    [
      _c("v-col", { attrs: { cols: "12", sm: _vm.props.nameCols } }, [
        _c("span", { staticClass: "font-weight-medium" }, [
          _vm._v(_vm._s(_vm.props.name))
        ])
      ]),
      _c("v-col", { attrs: { cols: "12", sm: _vm.props.valueCols } }, [
        _vm._v(" " + _vm._s(_vm.props.value) + " ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }